/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

/* eslint no-use-before-define:0*/

var Modal  = require('mag-component-modal'),
    List   = require('mag-component-list'),
    Scroll = require('spa-component-scrollbar'),
    modalScroll = new Scroll(),
    list   = new List({
        data: [],
        size: 0,
        className: 'padded',
        cycle: true,
        scroll: modalScroll,
        events: {
            'click:item': function ( event ) {
                console.log(event.$item.data);
                list.clickHandler(event.$item.data.valueToSet);
                popup.hide();
            }
        },
        propagate: true
    }),
    popup = new Modal({
        className: 'modalPopUp',
        children: [list],
        title: 'asd'
    });

popup.$body.appendChild(modalScroll.$node);

function construct ( config ) {
    var indexToFocus = 0,
        optionsData;

    config = config || {};

    if ( config.data ) {
        optionsData = config.data;
    } else if ( config.getOptions ) {
        optionsData = config.getOptions();
    }

    if ( config.getFocusIndex ) {
        indexToFocus = config.getFocusIndex();
    }

    popup.$text.innerText = config.title;
    list.clickHandler = config.handler;


    setTimeout(
        function () {
            list.init({
                data: optionsData.map(function ( element ) {
                    return {
                        value: element.title,
                        valueToSet: element.value
                    };
                }),
                scroll: modalScroll,
                size: optionsData.length > 5 ? 5 : optionsData.length,
                focusIndex: indexToFocus
            });

            popup.events = popup.events || {};

            if ( config.onHide ) {
                popup.events.hide = [config.onHide];
            }

            setTimeout(
                function () {
                    popup.show();
                    popup.focus();
                }, 100
            );
        }, 40
    );

}


module.exports = function ( page ) {
    page.add(popup);
    page.addListener('hide', function () {
        popup.hide();
    });

    return construct;
};
